import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

import { ThingsToDoService } from '../../services/things-to-do.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { CountryInfoService } from 'src/app/core/services/country-info.service';
import { CountryInfoTextService } from '../../services/country-info-text.service';
import { OccasionGeniusService } from 'src/app/core/services/occasion-genius.service';
import { HotelsProviderServiceService } from 'src/app/shared/used-components/hotels-booking-container/hotels-provider-service.service';

import { ThingsToDoMobileComponent } from '../../layout/mobile/things-to-do-mobile/things-to-do-mobile.component';
import { ThingsToDoDesktopComponent } from '../../layout/desktop/things-to-do-desktop/things-to-do-desktop.component';
import { HOTEL_CLIENT } from 'src/app/shared/used-components/hotels-booking-container/hotels-booking-container.component';

@Component({
  selector: 'app-things-to-do',
  templateUrl: './things-to-do.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CountryInfoService,
    ThingsToDoService,
    CountryInfoTextService,
    OccasionGeniusService,
    {
      provide: HOTEL_CLIENT,
      useClass: HotelsProviderServiceService,
    },
  ],
  imports: [ThingsToDoDesktopComponent, ThingsToDoMobileComponent],
})
export class ThingsToDoComponent {
  constructor(protected readonly breakpointService: BreakpointService) {}
}
